//  Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { initializeInterferenceAnalysis } from 'redux/modules/interferenceAnalysis/thunks'
import initializeEarthStationResultsForm from './initializeEarthStationResultsForm'

const initializeEarthStationResultsPage = () => async dispatch => {
  // this is really just a precaution in case the user skipped the AFS Grid page
  // and went straight to the Earth Station Results page.
  // If the user navigated to this page normally, this thunk will set everything
  // for us that we need.

  // NOTE - initializeInterferenceAnalysis will set analysisTypeId to its default value of AnalysisTypeIdEnum.ENVIRONMENT
  // HOWEVER - the analysisTypeId is important only for the AFS Grid since it allows the user to chose
  // between Environment and Intra-System analysis types on the same URL but for Earth Station,
  // we have our own page and the only thing we actually care about for display purposes here
  // is the selected bandId
  await dispatch(initializeInterferenceAnalysis())

  // then initialize the Earth Station Results Form so we can allow the user
  // to chose cases and generate a report accordingly.
  return dispatch(initializeEarthStationResultsForm())
}

export default initializeEarthStationResultsPage
